<template>
  <div id="MainHeader" class="fixed top-0 left-0 z-30 w-full">
    <router-link :to="$GetColumn('event_announcement_link')" v-if="$GetColumn('event_announcement') != ''"
      class="relative z-20 block py-2 text-sm font-medium text-center text-white bg-primary">
      <p>{{ $GetColumn("event_announcement") }}</p>
    </router-link>
    <div class="w-full relative z-10 h-[70px] bg-white border-b border-zinc-100 text-black">
      <div class="relative flex items-center justify-between w-full h-full px-5 mx-auto max-w-7xl">
        <button @click="$emit('menu-action')"
          class="p-2 -ml-2 text-gray-800 transition-colors lg:hidden hover:text-black">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>

        <router-link to="/"
          class="absolute z-10 flex items-center h-full transform -translate-x-1/2 -translate-y-1/2 lg:translate-x-0 lg:translate-y-0 lg:relative lg:top-auto lg:left-0 left-1/2 top-1/2">
          <img src="/img/logo.webp" :alt="$GetColumn('brand_name')" class="block h-[40px] md:h-[50px] w-auto" />
        </router-link>

        <div class="flex items-center h-full">
          <ol class="items-center hidden h-full mr-5 lg:flex">
            <li v-for="(item, item_index) in menu_list" :key="`list_item_${item_index}`"
              class="flex items-center h-full">
              <router-link
                class="flex items-center h-full px-3 text-sm font-bold transition-colors duration-300 text-zinc-700 hover:md:text-primary"
                :to="item.link">
                {{ item.title }}
              </router-link>
            </li>
          </ol>

          <div class="flex items-center gap-5">
            <!-- 1. 搜尋按鈕 (新增) -->
            <button @click="$store.commit('SetSearchDialog', true)"
              class="hidden text-gray-500 transition-colors md:block hover:text-black" title="搜尋商品">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
              </svg>
            </button>

            <!-- 2. 會員中心按鈕 (新增 - 直接連結) -->
            <router-link to="/account/login" class="hidden text-gray-500 transition-colors md:block hover:text-black"
              title="會員中心">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
            </router-link>

            <!-- 3. 購物車按鈕 (原本的) -->
            <button @click="$store.commit('SetShopCartStatus', true)"
              class="relative text-gray-500 transition-colors hover:text-black" title="購物車">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
              </svg>
              <span id="cart-count"
                class="absolute -top-1 -right-1 w-4 h-4 bg-primary text-white text-[10px] flex items-center justify-center rounded-full transition-transform duration-200"
                style="display: flex">{{ shopcart_count }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainHeader",
  data() {
    return {
      menu_list: [
        {
          title: "商品列表",
          sub_title: "Products",
          link: "/collections",
        },
        {
          title: "最新消息",
          sub_title: "News",
          link: "/news",
        },
        {
          title: "聯絡我們",
          sub_title: "Contact",
          link: "/contact",
        },
      ],
      drop_down: false,
      dialog_timer: null,
    };
  },
  props: {
    menu_status: {
      require: true,
      type: Boolean,
    },
  },
  methods: {
    OpenShopCart() {
      this.$store.commit("SetShopCartStatus", true);
    },
    // CloseShopCartDialog() {
    //   this.$store.commit("shopcart_module/SetAddCartMessage", false);
    // },
  },
  computed: {
    shopcart_count() {
      let count = 0;
      this.$store.state.shopcart_module.shopcart.forEach((item) => {
        count += item.amount;
      });
      return count;
    },
    // add_cart_message() {
    //   return this.$store.state.shopcart_module.add_cart_message;
    // },
  },
  // watch: {
  //   add_cart_message() {
  //     if (this.add_cart_message) {
  //       this.dialog_timer != null ? clearTimeout(this.dialog_timer) : "";
  //       this.dialog_timer = setTimeout(() => {
  //         this.CloseShopCartDialog();
  //       }, 5000);
  //     }
  //   },
  // },
};
</script>
